import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const StaticPage = ({ title, subtitle, children }) => (
  <div className="min-h-screen bg-white">
    {/* Hero */}
    <div className="bg-[#094f6f] py-16 px-4 text-white text-center">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-white/70 hover:text-white text-sm mb-6 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Home
        </Link>
        <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
        {subtitle && <p className="text-lg text-white/85 max-w-2xl mx-auto">{subtitle}</p>}
      </div>
    </div>

    {/* Content */}
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16">
      {children}
    </div>

    {/* Footer strip */}
    <div className="border-t border-gray-100 py-8 text-center">
      <Link to="/" className="text-[#094f6f] hover:underline font-medium">← Return to RentalX</Link>
    </div>
  </div>
);

export const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-2xl font-bold text-gray-900 mb-4 border-l-4 border-[#094f6f] pl-4">{title}</h2>
    <div className="text-gray-600 leading-relaxed space-y-3">{children}</div>
  </div>
);

export const CardGrid = ({ items }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-6">
    {items.map((item, i) => (
      <div key={i} className="border border-sky-100 rounded-xl p-6 hover:shadow-md transition-shadow bg-sky-50/30">
        <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
        <p className="text-sm text-gray-600">{item.desc}</p>
      </div>
    ))}
  </div>
);

export default StaticPage;
